import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Heart } from "lucide-react";

/**
 * Slim site-wide footer.
 * Visible on every page; honours mobile bottom-nav safe-area via index.css padding rules.
 */
export const Footer = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-border bg-background/60" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-10 py-8 space-y-4">
        <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
          <div className="text-xs font-mono uppercase tracking-[0.2em] text-muted-foreground">
            © {year} Split the <span className="brand-text">____</span>
          </div>
          <nav className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs">
            <Link to="/impressum" className="text-muted-foreground hover:brand-text transition" data-testid="footer-impressum">{t("footer.impressum", "Impressum")}</Link>
            <Link to="/privacy" className="text-muted-foreground hover:brand-text transition" data-testid="footer-privacy">{t("footer.privacy", "Privacy")}</Link>
            <Link to="/sponsors" className="text-muted-foreground hover:brand-text transition" data-testid="footer-sponsors">{t("footer.sponsors", "Sponsors")}</Link>
            <Link to="/feedback" className="text-muted-foreground hover:brand-text transition" data-testid="footer-feedback">{t("footer.feedback", "Feedback")}</Link>
          </nav>
        </div>
        <div className="text-[11px] text-muted-foreground/70 border-t border-border pt-4 flex items-center gap-1.5 justify-center sm:justify-start" data-testid="footer-tagline">
          Made with <Heart className="h-3 w-3 fill-current" strokeWidth={0} /> care in Straubing, Germany.
        </div>
      </div>
    </footer>
  );
};
